import { graphql } from 'gatsby'
import React, { FunctionComponent } from 'react'

import { AccentBlock } from '../components/AccentBlock'
import { Intro } from '../components/Intro'
import { Layout } from '../components/Layout'
import { SEO } from '../components/SEO'
import { StandardBlock } from '../components/StandardBlock'
import { EffectsSupported } from '../lib/effects'
import { FontSize } from '../type'

interface Graphics {
  source?: string
  author?: string
  image: any
}

interface Node {
  id: string
  html: string
  frontmatter: {
    graphics: Graphics[]
    widget: 'StandardBlock' | 'AccentBlock' | 'QuoteBlock'
    fontSize: FontSize
    effect?: EffectsSupported
    effectTimeout?: number
  }
}

interface Data {
  allMarkdownRemark: {
    nodes: Node[]
  }
}

interface Props {
  data: Data
}

const getWidget = (node: Node) => {
  const { frontmatter: { widget = '' } = {} } = node
  if (widget === 'AccentBlock') {
    return AccentBlock
  }

  return StandardBlock
}

const HomePage: FunctionComponent<Props> = ({ data }) => {
  const { allMarkdownRemark: { nodes = [] } = {} } = data
  return (
    <Layout>
      <SEO title="Home" keywords={['']} />
      <Intro />
      {nodes.map(node => {
        const Widget = getWidget(node)
        return (
          // @ts-ignore
          <Widget key={node.id} html={node.html} {...node.frontmatter} />
        )
      })}
    </Layout>
  )
}

export const query = graphql`
  query HomePageQuery {
    allMarkdownRemark(sort: { fields: frontmatter___sort, order: ASC }) {
      nodes {
        id
        html
        frontmatter {
          graphics {
            image {
              childImageSharp {
                fluid(maxWidth: 1240, quality: 80) {
                  ...GatsbyImageSharpFluid_tracedSVG
                }
              }
            }
            author
            source
            sourceText
          }
          widget
          fontSize
          effect
          effectTimeout
          id
        }
      }
    }
  }
`

export default HomePage
